<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        @if (showBackButton) {
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" data-specid="backButton"></ion-back-button>
        </ion-buttons>
        }
        <ion-title data-test="title" #title (click)="onTitleClick()">Live Tracker</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="more" [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="background ion-no-padding ion-text-center">
    <!-- 
<ion-content> -->
    <!-- <pre>{{ vectors | json }}</pre> -->
    @if (trackerLegend.visibility) {
    <div class="trackerLegend">
        <ion-list class="ion-padding">
            @for (shuttle of shuttles; track $index) {
            <ion-item>
                <ion-label>
                    <strong>{{shuttle.shuttleName}} - {{shuttle.color}}</strong><br />
                    {{getDriverFullName(shuttle)}}<br />
                    Speed: {{formatSpeed(shuttle.vector.speed.mph)}} mph<br />
                    Distance From Dealership: {{formatDistance(shuttle.vector.distanceFromDealership.miles)}}
                    miles<br />
                    @if (isDebugMode) {
                    <div>
                        Coordinate: ({{formatLocation(shuttle.vector.currentLocation)}})<br />
                    </div>
                    }
                    {{getNearbyLocation(shuttle.vector)}}
                </ion-label>
            </ion-item>
            }
        </ion-list>
    </div>
    }

    <!-- For Debugging -->
    <!-- @if (isDebugMode) {
  <div id="mapInfo">
        {{vm.mapInfoStr}}
    </div>
} -->

    <!-- <button class="centerMe" ion-button (click)="onCenterMeClick()">
        <img src="../../assets/images/dealershipMarker.png" />
    </button> -->

    <app-google-map [dealershipCoordinate]="dealershipCoordinate" [initialZoom]="8" [mapId]="'SHUTTLE_LIVE_TRACKER_MAP'"
        [showCenterButton]="false" (mapReady)="onMapReady()" (mapError)="onMapError($event)">
    </app-google-map>
</ion-content>